import { ModernTopBar } from './ModernLoader';

// ==============================|| Loader ||============================== //

const Loader = () => (
  <ModernTopBar />
);

export default Loader;
